import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import useOnClickOutside from 'use-onclickoutside'
import { RoundButton } from '../../common/components/button/RoundButton'
import { useUser } from '../../contexts/userContext'
import styles from './Topbar.module.css'
import { useTheme } from '../../contexts/ThemeContext'
import { PlayerUserMenuContainer } from '../UserMenu/PlayerUserMenu'

export const PlayerTopbar: React.FC = () => {
  const { t } = useTranslation()
  const [isUserMenuVisible, setIsUserMenuVisible] = React.useState(false)
  const menuRef = useRef<HTMLDivElement>(null)
  const { user } = useUser()
  const { logoUrl } = useTheme()

  useOnClickOutside(menuRef, () => {
    setIsUserMenuVisible(false)
  })

  const handleClosingMenu = () => {
    setIsUserMenuVisible(false)
  }

  return (
    <div className={styles.topBar}>
      {user?.isPlayerAccount && (
        <div className={styles.playerSeppoLogo}>
          <img width={90} src={logoUrl} alt='logo' />
        </div>
      )}
      <div onClick={() => setIsUserMenuVisible(true)} className={styles.userMenuDropdown}>
        <span className={styles.userInitials}>{user?.userInitials ?? ''}</span>
        <PlayerUserMenuContainer ref={menuRef} isUserMenuOpen={isUserMenuVisible} onMenuClose={handleClosingMenu} />
        <RoundButton
          style={{
            fontSize: '1.125rem',
            background: 'transparent',
            boxShadow: 'none',
            color: 'var(--grey-600)',
          }}
          icon={'arrowDown'}
          aria-label={
            isUserMenuVisible
              ? t('accessibility.user_menu_button.close', 'Close user menu')
              : t('accessibility.user_menu_button.open', 'Open user menu')
          }
        />
      </div>
    </div>
  )
}
